import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=55ae00fa&scoped=true"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=55ae00fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae00fa",
  null
  
)

export default component.exports